<template>
  <div class="col-12 step1">
    <div class="row">
      <div class="col p-0 m-1">
        <div class="step1_intro" v-if="this.$root.$store.state.optionValues">
          <p v-if="this.$root.$store.state.optionValues.enable_type_v && this.$root.$store.state.optionValues.enable_type_s && this.$root.$route.query.dev !== 'tab'"
              class="text-success design3 mt-4">
            {{$t('お申し込みには以下の2種類がございます。')}}<br>
          </p>
          <template v-if="this.$root.serviceSetting.User.id === '1'">
            <!-- <editor-fold desc="tkssp"> -->
            <template v-if="isS">
              <h3 class="mt-4 font-weight-bolder">{{$t('「通常の申し込み（取り置き無し）」')}}</h3>
              <div class="ml-md-4 mb-3 text-center">
                {{$t('※取り置きするシステムではございませんので、品切れの場合はご了承ください。')}}<br>
              </div>
            </template>
            <!-- </editor-fold> -->
          </template>
          <template v-else>
            <template v-if="isS && (!isRad || this.$root.serviceSetting.User.id === '5')">
              <!-- <editor-fold desc="pia"> -->
              <h3 class="mt-4 font-weight-bolder">{{$t('「通常の申し込み（取り置き無し）」')}}</h3>
              <div class="ml-md-4 mb-3 text-center">
                {{$t('※取り置きするシステムではございませんので、品切れの場合はご了承ください。')}}<br>
              </div>
              <!-- </editor-fold> -->
            </template>
          </template>

          <div class="text-center">
            <template v-if="this.$root.serviceSetting.User.id === '2'">
              <!-- <editor-fold desc="dyna"> -->
                <h3 class="mt-5 mt-md-4 text-center font-weight-bolder" v-if="isV">{{$t('「事前決済取り置きサービス」')}}</h3>
                <div v-if="(isV) && this.$root.$route.query.dev !== 'tab'" class="ml-md-4 mb-3 text-center">
                  {{$t('※専用レーンで優先でレンタル受付できます。')}}<br>
                  <template v-if="isRad">
                    <span v-if="this.$root.$store.state.fee">{{$t('message.2.fee500')}}</span><br>
                  </template>
                  <template v-else>
                    <span v-if="this.$root.$store.state.fee">{{$t('message.2.fee1000')}}</span><br>
                  </template>
                  {{$t('クレジットカード決済のみとなります。')}}<br>
                  {{$t(this.$root.serviceSetting.limittime_str.value)}}
                </div>
                <h3 class="mt-5 mt-md-4 text-center font-weight-bolder" v-if="isS && !isRad">{{$t('「事前予約取り置きサービス」')}}</h3>
                <div v-if="isS && !isRad" class="ml-md-4 mb-3 text-center">
                  {{$t('※専用レーンで優先でレンタル受付できます。')}}
                  <br>
                  <span v-if="this.$root.$store.state.fee">{{$t('1名500円の手数料がかかります。')}}</span><br>
                  {{$t(this.$root.serviceSetting.limittime_str.value)}}
                </div>
              <!-- </editor-fold> -->
            </template>
            <template v-else-if="this.$root.serviceSetting.User.id === '1' && isV">
              <!-- <editor-fold desc="tkssp"> -->
              <h3>{{$t('「事前決済取り置きサービス」')}}</h3>
              <div class="ml-md-4 mb-3 text-center">
                <template v-if="isRad">
                  {{$t('message.1.fee500')}}
                </template>
                <template v-else>
                  {{$t('message.1.fee1000')}}
                </template>
                <div>
                  {{$t('クレジットカード決済のみとなります。')}}
                </div>
                <div>
                  {{$t('ご利用日前日の12:00までお申し込みいただけます。')}}
                </div>
              </div>
              <!-- </editor-fold> -->
            </template>
            <template v-else>
              <!-- <editor-fold desc="common"> -->
              <h3 class="mt-5 mt-md-4 text-center font-weight-bolder" v-if="isV && this.$root.$route.query.dev !== 'tab'">{{$t('「事前決済取り置きサービス」')}}</h3>
              <div v-if="this.$root.$store.state.optionValues.enable_type_v && this.$root.$route.query.dev !== 'tab'" class="ml-md-4 mb-3 text-center">
                <span v-if="this.$root.$store.state.fee">{{$t('1名500円の手数料がかかります。')}}</span><br>
                {{$t('クレジットカード決済のみとなります。')}}<br>
                {{$t(this.$root.serviceSetting.limittime_str.value)}}
              </div>
              <!-- </editor-fold> -->
            </template>
            <template v-if="!isTab">
              <!-- <editor-fold desc="tablet"> -->
                   <div v-if="this.$root.$store.state.optionValues.enable_type_v && this.$root.$store.state.optionValues.enable_type_s" class="ml-md-4 mb-3 mt-4 text-center">
                     <strong>
                     {{$t('上記について申込画面の最後に選択してください。')}}
                     </strong>
                   </div>
              <!-- </editor-fold> -->
            </template>
          </div>
        </div>
        <template v-if="this.$root.serviceSetting.User.id !== '2'">
          <div class="ml-md-4 mb-3 text-center border-top p-3 border-bottom" style="font-size: 140%">
            <strong style="color: red">
              {{$t('グループでご来場予定の方はまとめてお申し込みください。')}}<br>
              {{$t('現地での貸し出しがスムーズになります。')}}
            </strong>
          </div>
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
          <div class="form-control-static design1">{{$t('message.language')}}</div>
          <div class="form-box">
            <div class="btn-group">
              <button
                  v-bind:class="{btn: true, 'btn-primary': this.$parent.$i18n.locale == 'ja', 'btn-light': this.$parent.$i18n.locale != 'ja'}"
                  v-on:click.prevent="changeLang('ja')">日本語
              </button>
              <button
                  v-bind:class="{btn: true, 'btn-primary': this.$parent.$i18n.locale == 'en', 'btn-light': this.$parent.$i18n.locale != 'en'}"
                  class="btn btn-default" v-on:click.prevent="changeLang('en')">English
              </button>
              <button
                  v-bind:class="{btn: true, 'btn-primary': this.$parent.$i18n.locale == 'cn', 'btn-light': this.$parent.$i18n.locale != 'cn'}"
                  class="btn btn-default" v-on:click.prevent="changeLang('cn')">中文
              </button>
            </div>
          </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <div class="form-group">
          <div class="form-control-static design1">
            <div>
              {{$t('message.rentalDate')}} *
            </div>
            <div class="mt-2">
              <span v-if="user.open"> {{user.open}} - {{user.close}} </span>
            </div>
          </div>
          <div class="form-box">
            <div class="row justify-content-center">
              <!-- !tab -->
              <div v-if="this.$root.$route.query.dev !== 'tab'">
                <div class="center-block">
                  <div class="form-inline">
                    <button class="btn btn-default" data-testid="step1_rental_date_open" @click="openRentalDatePicker"><i class="fas fa-calendar-alt"></i></button>
                    <datepicker
                        data-testid="step1_rental_date"
                        ref="rentalDatePicker"
                        :value="this.$root.$store.state.rentalDate"
                        @selected="updateRentalDate"
                        :language="datepickerLanguage"
                        input-class="form-control bg-white input-rental-date"
                        :disabled-dates="disabledDatesComputed"
                        :bootstrap-styling="true"
                        :format="customFormatter" />
                  </div>
                  <div v-for="(e, index) in showInputError('rentalDateY')" :key="'error-y-' + index"
                       class="text-danger">
                    {{$t(e.message)}}
                  </div>
                  <div v-for="(e, index) in showInputError('rentalDateM')" :key="'error-m-' + index"
                       class="text-danger">
                    {{$t(e.message)}}
                  </div>
                  <div v-for="(e, index) in showInputError('rentalDateD')" :key="'error-d-' + index"
                       class="text-danger">
                    {{$t(e.message)}}
                  </div>
                </div>
              </div>
              <!-- /!tab -->
              <!-- tab -->
              <div class="col-12" style="font-size: 1.4rem" v-if="this.$root.$route.query.dev === 'tab'">
                {{this.$root.$store.state.rentalDateY}} /
                {{this.$root.$store.state.rentalDateM}} /
                {{this.$root.$store.state.rentalDateD}}
              </div>
              <!-- /tab -->
            </div>
          </div>
          <div class="mx-auto">
            <div class="row">
              <div v-for="(e, index) in showInputError('rentalDate')" :key="'error-d-date-' + index"
                   class="text-danger">
                {{$t(e.message)}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <div class="form-group">
          <div class="form-control-static">{{$t('レンタル期間')}} *</div>
          <div class="btn-group-m1 form-box">
            <template v-for="(v, i) in this.terms">
              <button
                  v-if="v.Variable.active !== false"
                  :key="i"
                  :class="{btn: true, 'btn-light': $root.$store.state.reserve_term != v.Variable.code, 'btn-info': $root.$store.state.reserve_term == v.Variable.code}"
                  data-testid="step1_term"
                  @click="updateReserveTerm"
                  :value="v.Variable.code" >
                {{$t(v.Variable.name)}}
              </button>
            </template>
          </div>
          <div v-for="(e, index) in showInputError('reserve_term')" :key="'error-term-' + index"
               class="text-danger">
            {{$t(e.message)}}
          </div>
        </div>
      </div>
    </div>
    <!-- !tab -->
    <div class="row mt-4" v-if="this.$root.$route.query.dev !== 'tab' && this.willVisitOff === false">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <h3 class="design2">{{$t('ご来店可能な時間帯を選択してください')}}</h3>
            <div class="form-control-static design1">
              {{$t(this.texts.willVisit)}} *
            </div>
          </div>
            <div class="col-12">
              <div class="form-inline justify-content-center form-box">
                <div class="form-group" v-if="times && Object.keys(times).length > 0">
                                                                          <select class="form-control" data-testid="step1_will_visit" @input="updateWillVisit">
                                                                          <option v-for="(v, i) in times" :key="'times-' + i" :value="i"
                                                                          :selected="willVisit === i" :disabled="inActiveTimes.includes(v)">{{v}}
                                                                          </option>
                                                                          </select>
                                                                          </div>
                <div v-else>
                         <div class="text-danger">
                           {{$t('選択できる時間帯がありません。日付を確認してください')}}
                         </div>
                </div>
                <template v-if="this.texts.codeWillVisit === '02'">
                  <div class="form-group ml-md-2" v-if="times && Object.keys(times).length > 0">
                    {{$t('message.receiveTimeTo')}}
                  </div>
                  <div class="form-group ml-md-2" v-if="times && Object.keys(times).length > 0">
                    {{willVisitTo}}
                  </div>
                </template>
            </div>
          </div>
          <div class="form-group">
            <div v-for="(e, index) in showInputError('willVisit')" :key="'error-d-' + index"
                 class="text-danger">
              {{$t(e.message)}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /!tab -->
    <div class="row">
      <div class="col-12">
        <hr>
        <div class="form-group">
          <div v-if="this.$root.serviceSetting.prepaid_method && this.$root.serviceSetting.prepaid_method.value === 'SQUARE'" class="mb-3 text-center">
            <a href="#" data-testid="card_change_entry" @click.prevent="goCardChange">
              <i class="fas fa-credit-card"></i> {{ $t('message.card.entry_link') }}
            </a>
          </div>
          <button type="button" class="btn btn-outline-primary btn-sm mr-4 d-xs-block d-sm-block mb-4" data-testid="step1_reset" @click="reset">
            <i class="fas fa-undo-alt"></i> {{$t('リセット')}}
          </button>
          <div v-if="this.$root.serviceSetting.enable_privacy.value === 'true'">
            <button type="button" class="btn btn-sm" data-testid="privacy_open" @click="openPrivacyModal" style="margin-bottom: 14px;">
              ＞＞{{$t(privacyMsgPrefix + 'terms_of_use_title')}}
            </button>
          </div>
          <template v-if="times && Object.keys(times).length > 0">
            <button type="button" class="btn btn-primary btn-lg btn-h-6 Rental_cv1 btn-3d btn-sm-100" data-testid="nav_next" data-teststate="ready" @click="correctInit">
              {{$t('message.goToContact')}} <i class="fas fa-arrow-right"></i>
            </button>
          </template>
          <template v-else>
            <button type="button" class="btn btn-primary btn-lg btn-h-6 Rental_cv1 btn-3d btn-sm-100 disabled" style="color: #999;background-color: #ccc;border: 0;" disabled data-testid="nav_next" data-teststate="no_time_slot">
              {{$t('message.goToContact')}} <i class="fas fa-arrow-right"></i>
            </button>
          </template>
        </div>
      </div>
    </div>
    <div class="modal fade" data-backdrop="static" data-testid="consent_dialog" :id="'terms-of-use-' + this.$root.serviceSetting.User.id" tabindex="-1" role="dialog" aria-labelledby="label1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t(privacyMsgPrefix + 'terms_modal_header') }}</h4>
          </div>
          <div class="modal-body text-left">
            <div class="btn-group" style="margin-bottom: 20px;">
              <button
                  v-bind:class="{btn: true, 'btn-primary': this.$parent.$i18n.locale == 'ja', 'btn-light': this.$parent.$i18n.locale != 'ja'}"
                  v-on:click.prevent="changeLang('ja')">日本語
              </button>
              <button
                  v-bind:class="{btn: true, 'btn-primary': this.$parent.$i18n.locale == 'en', 'btn-light': this.$parent.$i18n.locale != 'en'}"
                  class="btn btn-default" v-on:click.prevent="changeLang('en')">English
              </button>
              <button
                  v-bind:class="{btn: true, 'btn-primary': this.$parent.$i18n.locale == 'cn', 'btn-light': this.$parent.$i18n.locale != 'cn'}"
                  class="btn btn-default" v-on:click.prevent="changeLang('cn')">中文
              </button>
            </div>
            <template>
              <div class="terms-of-use-1-content" v-html="$t(privacyMsgPrefix + 'terms_of_use')"></div>
              <p class="privacy_agreement">
                <label for="checkAgreeOptin1" _class="checkAgree" class="toggle-radio" style="margin: 10px 0;" @click="changePrivacy">
                  <input type="radio" name="checkAgree" class="checkAgree" data-testid="consent_agree" id="checkAgreeOptin1" value="1" :checked="this.$root.$store.state.privacy === '1'">
                  <span class="box"></span>
                  <span style="margin-left:10px">{{ $t(privacyMsgPrefix + 'agree') }}</span><br>
                </label>
                <label for="checkAgreeOptin0" _class="checkAgree" class="toggle-radio" style="margin: 10px 0 10px 20px;" @click="changePrivacy">
                  <input type="radio" name="checkAgree" class="checkAgree" data-testid="consent_disagree" id="checkAgreeOptin0" value="2" :checked="this.$root.$store.state.privacy === '2'">
                  <span class="box"></span>
                  <span style="margin-left:10px">{{ $t(privacyMsgPrefix + 'not_agree') }}</span><br>
                </label>
              </p>
              <p v-html="$t(privacyMsgPrefix + 'terms_of_use_note')"></p>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal" data-testid="consent_close" id="buttonClose" >{{$t("申し込む")}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'moment/locale/ja'
import moment from 'moment'
import axios from 'axios'
import Datepicker from 'vuejs-datepicker'
import { en, ja } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'ReserveInit',
  data () {
    return {
      en: en,
      ja: ja,
      willVisit: '',
      errors: [],
      times: {},
      timesFor: {},
      user: {},
      dispPMOnly: false,
      isHoliday: false,
      terms: {},
      disabledDates: [],
      inActiveTimes: [],
      willVisitOff: false,
      texts: {
        willVisit: '',
        codeWillVisit: '01'
      }
    }
  },
  components: {
    Datepicker
  },
  created () {
    this.getFee(null)
    this.getPublicKey()
    location.hash = ''
    // console.log('ReserveInit created', this.$root.$store.state)
  },
  computed: {
    privacyMsgPrefix () {
      return 'message.' + this.$root.serviceSetting.User.id + '.'
    },
    isTab () {
      return this.$root.$route.query.dev === 'tab'
    },
    isV () {
      if (this.$root.$route.query.type === 'V') {
        return true
      }
      if ((this.$root.$route.query.type === undefined || this.$root.$route.query.type === '') && this.$root.$store.state.optionValues.enable_type_v) {
        return true
      }
      return false
    },
    isS () {
      if (this.$root.$route.query.type === 'S') {
        return true
      }
      if ((this.$root.$route.query.type === undefined || this.$root.$route.query.type === '') && this.$root.$store.state.optionValues.enable_type_s) {
        return true
      }
      return false
    },
    isRad () {
      var isRad = false
      if (this.$root.$route.query.int && this.$root.$route.query.int.substr(-1) === '7') {
        isRad = true
      }
      return isRad
    },
    disabledDatesComputed () {
      let arr = {}
      let to = moment(this.user.open + ' 00:00:00').subtract(1, 'days')
      let from = moment(this.user.close + ' 23:59:59')
      arr = {
        to: new Date(to.format('YYYY-MM-DD')),
        from: new Date(from.format('YYYY-MM-DD')),
        dates: []
      }
      if (this.disabledDates && Object.keys(this.disabledDates).length > 0) {
        this.disabledDates.forEach(function (value) {
          // console.log('disableDates.value', value)
          let d = moment(value)
          arr.dates.push(new Date(d.format('YYYY-MM-DD')))
        })
      }
      return arr
    },
    datepickerLanguage () {
      // console.log('lang', this.$root.$store.state.lang)
      if (this.$root.$store.state.lang === 'ja') {
        return this.ja
      } else {
        return this.en
      }
    },
    willVisitTo () {
      return this.mathVisitTo()
    },
    isStayPlan () {
      let stayPlan = [
        'MON',
        'M07',
        'MA7',
        'MB7',
        'B07',
        'BA7',
        'BB7',
        'C07',
        'CA7',
        'CB7',
        'MC7',
        'BC7'
      ]
      return stayPlan.includes(this.$root.$route.query.type)
    },
    showPM () {
      let today = moment()
      let m = today.format('HHmm')
      // 当日 + 土日祝 + 午前中は表示しない
      if (this.$root.$store.state.rentalDate === today.format('YYYY/MM/DD') && parseInt(m) <= parseInt('1130') && this.isHoliday === true) {
        // return false
        // 2020/02/28 とりあえず表示する様に
        return true
      // 当日 + 土日祝 + 午後は表示する
      } else if (this.$root.$store.state.rentalDate === today.format('YYYY/MM/DD') && parseInt(m) > parseInt('1130') && this.isHoliday === true) {
        return true
        // 当日 土日祝以外は午後を表示する
      } else if (this.$root.$store.state.rentalDate === today.format('YYYY/MM/DD') && this.isHoliday === false) {
        return true
        // 事前 土日祝は午後を表示しない
      } else if (this.isHoliday === true) {
        // return false
        // 2020/02/28 とりあえず表示する様に
        return true
      } else {
        // 事前 全て表示
        return true
      }
    }
  },
  async mounted () {
    window.sendGtag({
      'page_path': '/reserve-app/step1'
    })
    window.scrollTo({ top: 0, behavior: 'smooth' })
    await this.getEntryTime()
    // console.log('getService')
    await this.getService()
    // console.log('getOptionValue')
    await this.getOptionValue()
    // console.log('setModal')
    // this.getCodes()
    this.initText()
    if (this.$root.serviceSetting.enable_privacy.value === 'true') {
      this.openPrivacyModal()
    }
    await this.$nextTick(function () {
      this.setDefaultTerm()
    })
    // console.log('mounted end')
  },
  methods: {
    openPrivacyModal () {
      let termOfUseModalId = '#terms-of-use-' + this.$root.serviceSetting.User.id
      // この名前のモーダルがあったら表示する
      if (window.$(termOfUseModalId).length > 0) {
        window.$(termOfUseModalId).modal('show')
      }
    },
    openRentalDatePicker () {
      this.$refs.rentalDatePicker.showCalendar()
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    initText () {
      let jsonStr = JSON.parse(this.$root.serviceSetting.entry_time.value)
      if (jsonStr.visible) {
        if (jsonStr.visible === 'false') {
          console.log('willVisitOff')
          this.willVisitOff = true
        } else {
          this.willVisitOff = false
        }
      }
      // console.log('jsonStr', jsonStr)
      // console.log('p.name', jsonStr.name)
      // console.log('p.code', jsonStr.code)
      if (jsonStr.name) {
        this.texts.willVisit = jsonStr.name
      }
      if (jsonStr.code) {
        this.texts.codeWillVisit = jsonStr.code
      }
      return true
    },
    // #226 与信NG後のカード変更（申込済の方はこちら）
    goCardChange () {
      this.$root.mode = 'card'
      this.$root.key = ''
      this.$router.push({ name: 'card-lookup' })
    },
    async reset () {
      this.$root.$store.commit('initState')
      // await this.getEntryTime()
      // this.getServiceSetting()
      // this.getService()
      // this.getOptionValue()
      // this.setDefaultTerm()
      // this.getCodes()
      // ui, int, dev, type は引き継いでリダイレクト
      let resetUrl = '/reserve-app/?ui=' + this.$root.$store.state.userId + '&'
      if (this.$root.$route.query.email !== undefined) {
        resetUrl += '&email=' + this.$root.$route.query.email
      }
      if (this.$root.$route.query.dev !== undefined) {
        resetUrl += '&dev=' + this.$root.$route.query.dev
      }
      if (this.$root.$route.query.type !== undefined) {
        resetUrl += '&type=' + this.$root.$route.query.type
      }
      if (this.$root.$route.query.int !== undefined) {
        resetUrl += '&int=' + this.$root.$route.query.int
      }

      window.sessionStorage.clear()
      console.log('resetUrl', resetUrl)
      window.location.href = resetUrl
    },
    setDefaultTerm () {
      if (this.isStayPlan) {
        this.$root.$store.commit('update', { field: 'reserve_term', value: '02' })
        this.dispPMOnly = false
        this.times = this.timesFor['02']
      } else {
        let tmp = moment()
        let m = tmp.format('HHmm')
        let selectedDate = this.$root.$store.state.rentalDate
        let defaultValue = '01'

        this.dispPMOnly = false
        if (selectedDate === tmp.format('YYYY/MM/DD') && parseInt(m) > parseInt('1130')) {
          defaultValue = 'PM'
          this.dispPMOnly = true
        }
        let existsDefaultValue = false
        let firstValue = ''
        if (this.terms) {
          this.$_.each(this.terms, (term) => {
            if (term.Variable.active === true) {
              if (firstValue === '') {
                firstValue = term.Variable.code
              }
              if (term.Variable.code === defaultValue) {
                existsDefaultValue = true
              }
            }
          })
        }
        if (!existsDefaultValue) {
          defaultValue = firstValue
        }
        // console.log('isStayPlan', this.isStayPlan)
        // console.log('defaultValue', defaultValue, this.terms)
        // console.log('firstValue', firstValue, this.terms)
        // console.log('exists', existsDefaultValue)
        this.$root.$store.commit('update', { field: 'reserve_term', value: defaultValue })
        this.times = this.timesFor[defaultValue]
      }
      return true
    },
    getServiceSetting () {
      this.$emit('get-service-setting')
      return true
    },
    mathVisitTo () {
      let t = this.$root.$store.state.willVisit
      if (t && this.times[t]) {
        let tmp = this.times[t]
        let m = moment(tmp, 'HH:mm')
        return m.add(10, 'minutes').format('HH:mm')
      }
      return null
    },
    changePrivacy (e) {
      if (e.target.value === undefined) {
        return
      }
      let value = e.target.value
      let current = this.$root.$store.state?.privacy
      if (current === value) {
        e.target.checked = false
        value = null
      }
      this.$root.$store.commit('update', { field: 'privacy', value: value })
      // 選択肢クリックでダイアログを閉じる(同意する/同意しない どちらでも)
      let termOfUseModalId = '#terms-of-use-' + this.$root.serviceSetting.User.id
      window.$(termOfUseModalId).modal('hide')
    },
    async getEntryTime () {
      this.resetError()
      let d = moment(this.$root.$store.state.rentalDate)
      let ui = this.$root.$route.query.ui ? this.$root.$route.query.ui : ''
      let int = this.$root.$route.query.int ? this.$root.$route.query.int : ''
      let dev = this.$root.$route.query.dev ? this.$root.$route.query.dev : ''
      let date = d.format('YYYY-MM-DD')

      let url = this.$root.baseURL + 'getEntryTime.json?d=' + date + '&ui=' + ui + '&type=' + int + '&dev=' + dev
      if (this.$root.$route.query?.debug_day) {
        url += '&debug_day=' + this.$root.$route.query.debug_day
      }
      if (this.$root.$route.query?.type) {
        url += '&rentalType=' + this.$root.$route.query.type
      }
      let _self = this

      window.jQuery('#loading-overlay').show()
      await axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'json'
      }).then(response => {
        // console.log('times', response.data.times)
        _self.times = response.data.times
        // console.log('timesFor', response.data.timesFor)
        _self.timesFor = response.data.timesFor
        _self.user = response.data.user.User
        if (this.$root.$store.state.reserve_term && _self.timesFor[this.$root.$store.state.reserve_term]) {
          _self.times = _self.timesFor[this.$root.$store.state.reserve_term]
        }
        if (response.data.inActiveTimes) {
          _self.inActiveTimes = response.data.inActiveTimes
        } else {
          _self.inActiveTimes = []
        }
        // _self.user = {
        //   open: '2021-01-12',
        //   close: '2022-05-31'
        // }
        _self.willVisit = this.$root.$store.state.willVisit
        _self.willVisit = response.data.default
        _self.$root.$store.commit('update', { field: 'willVisit', value: _self.willVisit })
        _self.isHoliday = response.data.values.isHoliday
        _self.terms = response.data.terms
        // terms の中に reserve_term がなければ最初のactiveなtermをセットする
        let existsReserveTerm = false
        _self.$_.each(_self.terms, (term) => {
          if (term.Variable.code === _self.$root.$store.state.reserve_term && term.Variable.active === true) {
            existsReserveTerm = true
          }
        })
        if (!existsReserveTerm) {
          const activeTerms = _self.$_.filter(_self.terms, (term) => term.Variable.active === true)
          if (activeTerms.length > 0) {
            // 現在の値がactiveTermsにあるならそのまま

            _self.$root.$store.commit('update', { field: 'reserve_term', value: activeTerms[0].Variable.code })
            // reserve_termに対応したtimesをセット
            _self.times = _self.timesFor[activeTerms[0].Variable.code]
          }
        }
        // -- terms の中に reserve_term がなければ最初のactiveなtermをセットする
        _self.disabledDates = response.data.disabledDates
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
        window.jQuery('#loading-overlay').hide()
      })
    },
    changeLang (lang) {
      if (this.$root.$store.state.lang === undefined) {
        return
      }
      if (this.$root.$store.state.lang === lang) {
        return
      }
      if (lang !== 'ja' && lang !== 'en' && lang !== 'cn') {
        lang = 'ja'
      }
      this.$root.$i18n.locale = lang
      this.$root.$store.commit('update', { field: 'lang', value: lang })
    },
    async updateRentalDate (value) {
      let w = moment(value)
      let Ymd = w.format('YYYY/MM/DD')
      let Y = w.format('YYYY')
      let M = w.format('MM')
      let D = w.format('DD')
      // console.log('updateRentalDate', Ymd)
      this.$root.$store.commit('update', { field: 'rentalDate', value: Ymd })
      this.$root.$store.commit('update', { field: 'rentalDateY', value: Y })
      this.$root.$store.commit('update', { field: 'rentalDateM', value: M })
      this.$root.$store.commit('update', { field: 'rentalDateD', value: D })

      // getFee, getEntryTime, getServiceSetting, setDefaultTermこの順序で実行したい

      await this.getFee(Ymd)
      await this.getEntryTime()
      this.getServiceSetting()
      this.setDefaultTerm()
    },
    updateRentalDateY (e) {
      this.$root.$store.commit('update', { field: 'rentalDateY', value: e.target.value })
      let Ymd = this.$root.$store.state.rentalDateY + '/' + this.$root.$store.state.rentalDateM + '/' + this.$root.$store.state.rentalDateD
      this.$root.$store.commit('update', { field: 'rentalDate', value: Ymd })
      this.getEntryTime()
      this.setDefaultTerm()
    },
    updateRentalDateM (e) {
      this.$root.$store.commit('update', { field: 'rentalDateM', value: e.target.value })
      let Ymd = this.$root.$store.state.rentalDateY + '/' + this.$root.$store.state.rentalDateM + '/' + this.$root.$store.state.rentalDateD
      this.$root.$store.commit('update', { field: 'rentalDate', value: Ymd })
      this.getEntryTime()
      this.setDefaultTerm()
    },
    updateRentalDateD (e) {
      this.$root.$store.commit('update', { field: 'rentalDateD', value: e.target.value })
      let Ymd = this.$root.$store.state.rentalDateY + '/' + this.$root.$store.state.rentalDateM + '/' + this.$root.$store.state.rentalDateD
      this.$root.$store.commit('update', { field: 'rentalDate', value: Ymd })
      this.getEntryTime()
      this.setDefaultTerm()
    },
    updateWillVisit (e) {
      this.$root.$store.commit('update', { field: 'willVisit', value: e.target.value })
      this.resetError()
      this.willVisit = e.target.value
      this.dispPMOnly = e.target.value.replace('t', '') > 1120
    },
    correctInit (e) {
      if (this.checkForm() === true) {
        if (this.$root.$route.query.dev !== 'tab' && this.willVisitOff === false) {
          this.checkWillVisit()
        } else {
          this.$root.$store.commit('update', { field: 'step', value: 2 })
        }
      }
    },
    updateReserveTerm (e) {
      let v = e.target.value
      this.$root.$store.commit('update', { field: 'reserve_term', value: v })
      if (this.timesFor[v] && Object.keys(this.timesFor[v]).length > 0) {
        this.times = this.timesFor[v]
        if (this.times && Object.keys(this.times).length > 0) {
          let min = Object.entries(this.times)[0]
          this.$root.$store.commit('update', { field: 'willVisit', value: min[0] })
          this.willVisit = min[0]
        }
        this.mathVisitTo()
      } else {
        this.times = []
      }
    },
    checkWillVisit: async function () {
      let url = this.$root.baseURL +
          'checkWillVisit.json?d=' +
          this.$root.$store.state.rentalDate +
          '&w=' + this.$root.$store.state.willVisit +
          '&type=' + this.$root.$route.query.type
      let _self = this
      let res = false
      await axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'json'
      }).then(response => {
        let count = response.data.count
        let limit = response.data.limit
        if (count >= limit) {
          _self.addError('willVisit', 'この時間帯は受付人数が最大に達しています')
          res = false
        } else {
          res = true
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        if (res === true) {
          _self.$root.$store.commit('update', { field: 'step', value: 2 })
        }
        return res
      })
    },
    checkForm () {
      this.errors = []
      let v = this.$root.$store.state
      if (v.rentalDateY === '') {
        this.addError('rentalDateY', 'message.errors.required')
      }
      if (v.reserve_term === '') {
        this.addError('reserve_term', 'message.errors.required')
      }
      if (v.rentalDateM === '') {
        this.addError('rentalDateM', 'message.errors.required')
      }
      if (v.rentalDateD === '') {
        this.addError('rentalDateD', 'message.errors.required')
      }
      let tmp = moment()
      let today = moment(tmp.format('YYYY/MM/DD') + ' 00:00', 'YYYY/MM/DD HH:mm')
      let reserve = moment(this.$root.$store.state.rentalDate, 'YYYY/MM/DD')
      let open = moment(this.user.open + ' 00:00', 'YYYY/MM/DD HH:mm')
      let close = moment(this.user.close + ' 23:59', 'YYYY/MM/DD HH:mm')
      let start = moment(this.$root.$store.state.rentalDate + ' ' + this.mathVisitTo(), 'YYYY/MM/DD HH:mm')
      let now = moment()
      if (this.$root.$route.query.debug_day && this.$root.$route.query.debug_day.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/)) {
        now = moment(this.$root.$route.query.debug_day, 'YYYY-MM-DD HH:mm')
      }
      let dateErrorExists = false
      if (!reserve.isValid()) {
        dateErrorExists = true
        this.addError('rentalDate', 'message.errors.date')
      } else {
        if (start < now && this.$root.$route.query.dev !== 'tab' && this.willVisitOff === false) {
          // console.log('start', start)
          // console.log('now', now)
          dateErrorExists = true
          this.addError('willVisit', '無効な時刻です。過去の時刻に設定することはできません。')
        }
        if (reserve < open && dateErrorExists === false) {
          dateErrorExists = true
          this.addError('rentalDate', 'message.errors.date')
        }
        if (reserve > close && dateErrorExists === false) {
          dateErrorExists = true
          this.addError('rentalDate', 'message.errors.date')
        }
        if (reserve < today && dateErrorExists === false) {
          dateErrorExists = true
          this.addError('rentalDate', 'message.errors.date')
        }
      }
      if (this.errors.length > 0) {
        return false
      }
      return true
    },
    showInputError (field) {
      let res = this.$_.where(this.errors, { field: field })
      if (res) {
        return res
      }
    },
    addError (field, message) {
      this.errors.push({
        field: field,
        message: message
      })
    },
    resetError () {
      this.errors = []
    },
    async getFee (Ymd) {
      if (Ymd === null) {
        Ymd = this.$root.$store.state.rentalDate
      }
      let int = (this.$root.$route.query.int) ? this.$root.$route.query.int : ''
      let url = this.$root.baseURL + 'getFee2.json?d=' + Ymd + '&int=' + int

      // async 処理に変更
      return axios.get(url).then(response => {
        this.$root.$store.commit('update', { field: 'fee', value: Number(response.data) })
      }).catch(error => {
        console.log('getFee__エラー', error)
      }).finally(() => {
        // console.log('fee', this.$root.$store.state.fee)
      })
    },
    getPublicKey () {
      let url = this.$root.baseURL + 'getPublicKey.json'
      axios.get(url).then(response => {
        this.$root.$store.commit('update', { field: 'publicKey', value: response.data })
      }).catch(error => {
        console.log('getPublicKey__エラー', error)
      }).finally(() => {
        // this.$root.$store.state.loading = false
      })
    },
    getService () {
      let int = (this.$root.$route.query.int) ? this.$root.$route.query.int : ''
      let ui = this.$root.$route.query.ui ? this.$root.$route.query.ui : ''
      let url = this.$root.baseURL + 'getService.json?id=' + ui + '&int=' + int
      let _self = this
      axios.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        responseType: 'json'
      }).then(response => {
        let service = response.data.user.User

        let serviceName = service.name + ' ' + service.name_service
        if (response.data.systemOptions.introduce_name) {
          serviceName += ' (' + response.data.systemOptions.introduce_name + ')'
        }
        window.$('#SystemTitle').text(serviceName)
        window.$('title').text(serviceName)
        let userId = {
          field: 'userId',
          value: response.data.user.User.id
        }
        _self.$root.$store.commit('update', userId)
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
      })
    },
    getYears () {
      return this.getTerms(true)
    },
    getMonth () {
      return this.getTerms(false)
    },
    getTerms (year) {
      let start = moment(this.user.open, 'YYYY-MM-DD')
      let end = moment(this.user.close, 'YYYY-MM-DD')
      var array = year ? [start.get('y')] : []
      let state = year ? 'y' : 'M'
      end.endOf('month')
      for (var i = start; i <= end; i = i.add(1, state)) {
        if (array.length < 12) {
          array.push(i.get(state) + 1)
        }
      }
      return array
    },
    setDate () {
      let start = moment(this.user.open, 'YYYY-MM-DD')
      let end = moment(this.user.close, 'YYYY-MM-DD')
      this.selectMonth = ('0' + (start.get('M') + 1)).slice(-2)
      var count = 0
      for (var i = start; i < end; i = i.add(1, 'M')) {
        let month = moment([i.get('y'), i.get('M')])
        var day = []
        let startDay = count === 0 ? start.date() : 1
        let endDay = end.month() === i.get('M') ? end.date() : month.endOf('M').date()
        for (let d = startDay; d <= endDay; d++) { day.push(d) }
        this.days[('0' + (i.get('M') + 1)).slice(-2)] = day
        count++
      }
      this.dayOptions = this.days[this.selectMonth]
    },
    getOptionValue () {
      var int = (this.$root.$route.query.int) ? this.$root.$route.query.int : ''
      var url = this.$root.baseURL + 'getOptionName.json?ui=' + this.$root.$route.query.ui + '&int=' + int
      axios.get(url, {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'json'
      }).then(response => {
        let obj = response.data.result
        let options = {}
        Object.keys(obj).forEach(function (key) {
          if (obj[key].Option) {
            if (obj[key].Option.value === 'true') {
              options[key] = true
            } else if (obj[key].Option.value === 'false') {
              options[key] = false
            } else {
              options[key] = obj[key].Option.value
            }
          } else {
            options[key] = ''
          }
        })
        // console.log('-------options--------')
        // console.log(options)
        // console.log(options.enable_allocate_stocks)
        // options.enable_allocate_stocks = true
        if (options.enable_type_v && this.$root.$route.query.type === 'V') {
          options.enable_type_s = false
        }
        if (options.enable_type_s && this.$root.$route.query.type === 'S') {
          options.enable_type_v = false
        }
        this.$root.$store.commit('update', { field: 'optionValues', value: options })
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.$root.$store.state.loading = false
      })
    }
  }
}
</script>
<style>
    .btn-light {
        background-color: #ececec;
    }
    .terms-of-use-1-content p {
      font-size: 15px;
      margin: 0 0 20px 0;
    }
    .terms-of-use-1-content p.header {
      font-size: 17px;
      margin: 0 0 20px 0;
    }
    #loading {
      display: none;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      margin: 0;
      padding: 0;
      background-color: rgba(255, 255, 255, 0.5);
    }
    .input-rental-date {
      min-width: 210px;
    }
    .toggle-radio input[type="radio"] {
      display: none;
    }
    .toggle-radio {
      cursor: pointer;
      user-select: none;
    }

    .toggle-radio .box {
      display: inline-block;
      width: 16px;
      height: 16px;
      border: 2px solid #555;
      margin-right: 6px;
      vertical-align: middle;
    }

    .toggle-radio input[type="radio"]:checked + .box {
      background: #007BFF;
      position: relative;
    }

    .toggle-radio input[type="radio"]:checked + .box::after {
      content: '✔';
      color: white;
      font-size: 14px;
      position: absolute;
      top: -2px;
      left: 2px;
    }
</style>
